var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22 0.470011C5.36063 0.329561 5.55125 0.250671 5.75 0.250671C5.94875 0.250671 6.13937 0.329561 6.28 0.470011L10.53 4.72001C10.6705 4.86064 10.7493 5.05126 10.7493 5.25001C10.7493 5.44876 10.6705 5.63939 10.53 5.78001L6.28 10.03C6.13785 10.1627 5.94975 10.2349 5.75536 10.2316C5.56097 10.2282 5.37548 10.1495 5.238 10.012C5.10053 9.87453 5.02181 9.68904 5.01846 9.49465C5.0151 9.30026 5.08736 9.11216 5.22 8.97001L8.19 6.00001H0.75C0.551088 6.00001 0.360322 5.92099 0.21967 5.78034C0.0790175 5.63969 0 5.44892 0 5.25001C0 5.0511 0.0790175 4.86033 0.21967 4.71968C0.360322 4.57903 0.551088 4.50001 0.75 4.50001H8.19L5.22 1.53001C5.07955 1.38939 5.00066 1.19876 5.00066 1.00001C5.00066 0.801261 5.07955 0.610637 5.22 0.470011Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.a9731a3a3c580ab6e0970649d00e6c5a.svg";
export { ForwardRef as ReactComponent };